import { FileView } from 'modules/common/types';
import { GetPaymentPriceResponse } from '../payments/types';
import { GetProofsResponseTransformed } from '../evidence/types';

export interface IUnauthSharedFolder {
    id: string;
    situationId: string;
    username: string;
    email: string;
    sharingUrlExpirationDate: string;
    situationName: string;
    sharedDate: string;
    evidences: (FileView & { evidenceId: string })[];
    numberOfViews: number;
    formattedTransactionNumber: string;

    recipientName: string;
    recipientEmail: string;
    chatAvailable?: boolean;
}

export enum CopyTypes {
    Unauthenticated = 'unauthenticated',
    Authenticated = 'authenticated',
}

export interface CreateShareFolderUrlRequest {
    active?: boolean;

    situationId?: string;
    evidencesIdList: string[];
    sharingUrlExpirationDate: string;
    copyType: CopyTypes;
    authorName?: string;
    recipientName?: string;
    recipientEmail?: string;
    createChat?: boolean;
}

export interface CreateShareFolderUrlResponse {
    sharingUrl?: string;
    token?: string;
}

export interface SharingPriceResponse {
    paymentNeeded: boolean;
    evidencesIdListPaymentNeeded?: string[];
    paymentDetails?: GetPaymentPriceResponse;
}

export interface SharingPriceRequest {
    evidencesIdList: string[];
    copyType: CopyTypes;
}

export interface SendSharingCodeRequest {
    email: string;
    token: string;
}

export interface CheckSharingCodeRequest {
    codeId: string;
    userValue: string;
}

export interface CheckSharingCodeResponse {
    correct: boolean;
    accessToken: string;
}

export interface GetProofMetadataRequest {
    folderId: string;
    proofId: string;
}

export interface IFolderShareRequest {
    folderId: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
}

export interface ISharedFolderDetails {
    phoneNumber: string;
    email: string;
}

export interface ISharedEvidence {
    allowUploads: boolean;
    proofs: GetProofsResponseTransformed;
}

export interface ChatMessage {
    id: string;
    content: string;
    senderEmail: string;
    senderName: string;
    isRegistered: boolean;
    createdAt: string;
}

export interface ChatParticipant {
    email: string;
    name: string;
    is_registered: boolean;
}

export interface ChatData {
    id: string;
    isArchived: boolean;
    archivedAt: string | null;
    archiveConfirmed: boolean;
    archiveConfirmedAt: string | null;
    isReadOnly: boolean;
    messages: ChatMessage[];
    participants: ChatParticipant[];
    sharedEvidenceId: string;
}

export interface SendMessageRequest {
    sharingId: string;
    content: string;
}

export interface SendMessageResponse {
    id: string;
    content: string;
    senderEmail: string;
    senderName: string;
    isRegistered: boolean;
    createdAt: string;
}

export interface ArchiveChatRequest {
    sharingId: string;
    confirm: boolean;
}

export interface SharedEvidence {
    evidenceId: string;
    evidenceSharingUrl: string;
    name: string;
    city: string;
    mediaType: string;
    fileFormat: string;
    uploadedAt: string;
    thumbnail: string;
}

export interface SharingWithChats {
    username: string;
    sharingUrlExpirationDate: string;
    situationName: string;
    situationId: string;
    sharedDate: string;
    evidences: SharedEvidence[];
    numberOfViews: number;
    formattedTransactionNumber: string;
    recipientName: string;
    recipientEmail: string;
    messageCount: number;
    lastMessageDate: string;
    isArchived: boolean;
    id: string;
}
